import { type JSX } from 'react'

import { SelectListbox, type SelectListboxProps } from 'base-ui'

import { ProductSearchRefinementRatingListboxBody } from './ProductSearchRefinementRatingListboxBody'

export const ProductSearchRefinementRatingListbox = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>(
  props: SelectListboxProps<OptionValue, Multiple>,
): JSX.Element => {
  return (
    <SelectListbox
      {...props}
      slots={{ body: ProductSearchRefinementRatingListboxBody }}
    />
  )
}
